import web3Singletone from '../configWeb3';
import { abi, networks } from '../../build_sidechain/contracts/Toi';
import { getFunctionOutputAbi, paramParser, getEventOutputAbi } from './contractHandle';

class Toi {
  // toiContract;
  // configWeb3;
  // privateKeyBase64;
  constructor(privateKeyBase64) {
    const web3 = web3Singletone.getWeb3(privateKeyBase64);
    this.publicAddress = web3Singletone.getPublicAddress(privateKeyBase64);
    this.toiContract = new web3.eth.Contract(abi, networks[web3Singletone.getNetwork()].address, {
      from: this.publicAddress
    });
  }

  async balanceOf(address) {
    if (!address) {
      address = this.publicAddress;
    }
    const balance = await this.toiContract.methods.balanceOf(address).call();
    return balance.toString();
  }
}

export default Toi;
